import { formatCurrency, HotDeal, ProductSession } from '@big-red-group/storefront-common-checkout'
import { LastMinutePricingDate } from '@/types'
import { SelectedOption } from '@/types'
import { addCurrency, multiplyCurrency } from '@/helpers/CurrencyHelper'

export const getHotDeals = (productSessions: ProductSession[], sessionId?: number) => {
  return productSessions.find((session) => (sessionId && session.id === sessionId) || session.hotDeal != undefined)
    ?.hotDeal?.message
}

export const getDisplayHotDeal = (hotDeals: HotDeal[] | string) => {
  // If no hot deals
  if (!hotDeals || hotDeals.length === 0) return null

  // If only one deal
  if (typeof hotDeals === 'string') {
    return hotDeals
  }

  // If multiple deals
  const allDeals = hotDeals.map((deal) => deal.message)
  if (allDeals.every((singleDeal) => singleDeal === hotDeals[0].message)) {
    return hotDeals[0].message
  } else {
    return 'See all deals'
  }
}

export const formatTimeWithAmPm = (hours: number, minute: number | undefined): string | undefined => {
  if (!hours) {
    return undefined
  }

  const date = new Date()
  date.setHours(hours)
  date.setMinutes(minute || 0)
  return date.toLocaleTimeString('en-AU', { hour: 'numeric', minute: 'numeric', hour12: true })
}

export const getLastMinuteDiscount = (lastMinuteDate: LastMinutePricingDate): string | null => {
  const { discountAmount, discountPercentage } = lastMinuteDate

  return discountPercentage ? `${discountPercentage}%` : discountAmount ? formatCurrency(discountAmount) : null
}

export const getTotal = (acc: number, curr: SelectedOption) => {
  const extrasTotal =
    curr.extras?.reduce((acc, curr) => addCurrency(acc, multiplyCurrency(curr.price, curr.quantity)), 0) || 0
  const itemsTotal = multiplyCurrency(curr.price, curr.quantity)
  return addCurrency(acc, addCurrency(itemsTotal, extrasTotal))
}

export const getExtrasTotal = (acc: number, curr: SelectedOption) => {
  const extrasTotal =
    curr.extras?.reduce((acc, curr) => addCurrency(acc, multiplyCurrency(curr.price, curr.quantity)), 0) || 0
  return addCurrency(acc, extrasTotal)
}
